export enum VuAutomaticActionType {
  None = 'None',
  FMCU = 'FMCU',
  FMCUWaitForEntrance = 'FMCUWaitForEntrance',
}
